import React, { Component, Suspense, useEffect, useState } from 'react'
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import './assets/style/global.css'
import { useAuth } from './views/pages/auth/AuthContext'
import { useAuthStd } from './views/pages/auth/AuthContextStd'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Enrollment=React.lazy(() => import('./views/pages/enrollment/index'))
const Enroll=React.lazy(() => import('./views/pages/enrollment/enroll/index'))
const Validate=React.lazy(() => import('./views/pages/enrollment/validate/index'))
const Student=React.lazy(() => import('./views/pages/enrollment/validate/student/index'))
const Confirm=React.lazy(() => import('./views/pages/enrollment/confirmation/index'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Recover = React.lazy(() => import('./views/pages/recover/Recover'))
const ConfirmCode = React.lazy(() => import('./views/pages/confirmCode/ConfirmCode'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

const App=()=> {
  const { isAuthenticated, setIsAuthenticated } = useAuth()
  const { isStdAuthenticated, setIsStdAuthenticated } = useAuthStd()
  const [user,setUser]=useState({})
  const [student,setStudent]=useState({})

  useEffect(() => {
    const loggedInUser = localStorage.getItem("student")

    try{
      setStudent(JSON.parse(loggedInUser))
      setIsStdAuthenticated(true)
    }catch(e){
      setStudent({})
    }
  }, [])

  useEffect(() => {
    const loggedInUser = localStorage.getItem("user")

    try{
      setUser(JSON.parse(loggedInUser))
      setIsAuthenticated(true)
    }catch(e){
      setUser({})
    }
  }, [])
  
  return (
    <HashRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route exact path="/inscricao" name="Inscrição" element={<Enrollment />} />
          <Route exact path="/inscrever" name="Inscrever" element={<Enroll />} />
          <Route exact path="/confirmar" name="Confirmar" element={<Confirm />} />
          <Route exact path="/validar" name="Validar" element={<Validate />} />
          <Route exact path="/validar/estudante" name="Estudante" element={<Student/>} />
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route exact path="/register" name="Register Page" element={<Register />} />
          <Route exact path="/recover" name="Recover Page" element={<Recover />} />
          <Route exact path="/confirmCode" name="Confirm Code" element={<ConfirmCode />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route
            path="*"
            name="Home" 
            element={(isAuthenticated || Boolean(user)) ? <DefaultLayout /> : <Navigate to="/login"/>}
          />
          <Route
            path="/validar/estudante"
            name="Validar Inscrição" 
            element={(isStdAuthenticated || Boolean(student)) ? <Student/> : <Navigate to="/validar" />}
          />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default App
